<template>
    <div class="choose-time-container">
        <!-- 
        test-btn
        <div class="btn-container">
            <div class="btn-span" @click="() => show = !show">123</div>
        </div> -->
        <van-popup v-model="show" position="bottom">
            <div class="switch-data-box flex flex-row flex-row-aic">
                <div class="left">
                    <span @click="() => swt = 0" :class="{ 'active': swt === 0 }">{{ dateShow }}</span>
                    <span @click="() => swt = 2" :class="{ 'active': swt === 2 }">时间</span>
                </div>
                <div class="right" @click="handleConfirmBtn">
                    <div class="btn">确认</div>
                </div>
            </div>
            <van-calendar ref="calendarRef" v-show="swt === 0" :poppable="false" :show-confirm="false" :show-title="false"
                :show-subtitle="false" :style="{ height: '340px' }" row-height="50" color="#3290c4" :min-date="minDate"
                :max-date="maxDate" @confirm="handleConfirmDateVal" :default-date="dateVal" />

            <van-datetime-picker v-show="swt === 2" :value="timeVal" type="time" title="选择时间" :style="{ height: '340px' }"
                :min-hour="0" :max-hour="23" :show-toolbar="false" visible-item-count="8"
                @change="handleDateTimePickerChange" />
            <!-- <div class="swtbox2" >
            </div> -->
        </van-popup>
    </div>
</template>

<style lang="less" scoped>
.choose-time {
    &-container {}
}

.switch-data-box {
    justify-content: space-between;
    padding: 0 12px;

    span {
        display: inline-block;
        font-size: 14px;
        font-weight: 400;
        color: #707073;
        padding: 10px 8px;
        margin-right: 6px;

        &.active {
            border-bottom: 2px solid #707073;
        }

        &:last-child {
            margin-right: 0;
        }
    }

    .right {
        font-size: 16px;
        font-weight: 500;
        color: #3290C4;
        line-height: 22px;
    }

    .dheig {
        height: 350px;
    }
}

.swtbox2 {
    padding: 20px 0;
    box-sizing: border-box;
}
</style>

<script>
import dayjs from 'dayjs';
import { formatTime } from '@/utils/formatTime';
export default {
    name: "ChooseTime",
    computed: {
        dateShow() {
            return this.dateVal ? formatTime(this.dateVal) : '日期'
        },
    },
    props: {
        value: {
            type: [String, Date],
        },
        ctype: { // range=选择范围
            // :max-range="3" 最大可选择的范围
            type: String,
            default: ''
        },
        // NOTE: 默认最小时间当天的0:0:0起
        // 最大时间按照当前的六个月以后的23:59:59止
        minDate: {
            type: Date,
            default: () => {
                let now = new Date()
                now.setHours(0, 0, 0)
                return now
            }
        },
        maxDate: {
            type: Date,
            default: () => {
                let now = new Date()
                now.setMonth(now.getMonth() + 7)
                now.setHours(23, 59, 59)
                return now
            }
        }
    },
    data() {
        return {
            show: false,
            swt: 0,
            timeVal: '00:00',
            dateVal: new Date(),
            callback: null
        }
    },
    methods: {
        openChooseTime(callback) {
            this.show = true
            if (callback) this.callback = callback
        },
        reset() {
            this.swt = 0
            this.timeVal = '00:00'
            this.dateVal = new Date()
        },
        getTime() {
            let cnow = new Date(this.dateVal)
            const [h, m] = this.timeVal.split(':')
            cnow.setHours(h)
            cnow.setMinutes(m)
            return cnow
        },
        // time picker change
        handleDateTimePickerChange(picker) {
            const [hours, minus] = picker.getValues()
            this.timeVal = `${hours}:${minus}`
        },
        // confirm date
        handleConfirmDateVal(date) {
            this.dateVal = date
        },

        // confirm btn.
        handleConfirmBtn() {
            this.show = false
            let cnow = new Date(this.dateVal)
            const [h, m] = this.timeVal.split(':')
            cnow.setHours(h)
            cnow.setMinutes(m)
            if (this.$listeners.input) this.$emit('input', cnow)
            if (this.$listeners.confirm) this.$emit('confirm', cnow)
            if (this.callback) this.callback(cnow)
        }
    },
    watch: {
        value: {
            handler(dateStr) {
                if (dateStr) {
                    let _date = dayjs(dateStr).format('YYYY-MM-DD')
                    let time = dayjs(dateStr).format('HH:mm')
                    this.dateVal = new Date(_date)
                    this.timeVal = time
                }
            },
            immediate: true
        }
    }
}
</script>